import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from 'contexts/AuthContext';
import { DarkModeProvider } from 'contexts/DarkModeContext';
import { MonthProvider } from 'contexts/MonthContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <DarkModeProvider>
      <ThemeCustomization>
        <AuthProvider>
          <MonthProvider>
            <ScrollTop>
              <RouterProvider router={router} />
            </ScrollTop>
          </MonthProvider>
        </AuthProvider>
      </ThemeCustomization>
    </DarkModeProvider>
  );
}